/* eslint-disable import/prefer-default-export */

export async function getPipedriveDeals() {
  if (typeof window === `undefined` || typeof fetch === `undefined`) {
    return null;
  }

  const url = `${process.env.GATSBY_NETLIFY_FUNCTIONS}/get-pipedrive-deals`;

  const response = await fetch(url, {
    headers: new Headers({
      "Content-Type": `application/json`
    }),
    method: `POST`
  });

  return response;
}

export async function createPipedriveDeal(deal) {
  if (typeof window === `undefined` || typeof fetch === `undefined`) {
    return null;
  }

  const url = `${process.env.GATSBY_NETLIFY_FUNCTIONS}/add-pipedrive-deal`;

  const response = await fetch(url, {
    body: JSON.stringify({
      deal
    }),
    headers: new Headers({
      "Content-Type": `application/json`
    }),
    method: `POST`
  });

  return response;
}
